import React, { useEffect, useRef } from 'react';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { setWidthHeight } from '../redux/actions/widthHeightActions';
import getWindowSize from '../utils/getWindowSize';
import UsersHeader from './Users/UsersHeader';
import useGetRequest from '../hooks/useGetRequest';
import { setAllData } from '../redux/actions/restaurantActions';
import restaurantSelector from '../redux/selectors/restaurantSelector';
import UsersFooter from './Users/UsersFooter';
import UsersVisitUs from './Users/UsersVisitUs';

function HomeVisitUs() {
  const { number } = useSelector(restaurantSelector);
  const { data, isLoading, refetch } = useGetRequest('restaurantData', '/taquito/users/restaurant/info', { number }, true, false);
  const dispatch = useDispatch();
  const { name, facebook, email, instagram, phoneNumber, address, mapsSrc, mapsDir } = data?.info || {};
  const firstPaint = useRef(true);

  useEffect(() => {
    if (!isLoading) dispatch(setAllData(name, facebook, email, instagram, phoneNumber, address, mapsSrc, mapsDir, data.promotions || []));
  }, [data]);

  useEffect(() => {
    if (firstPaint.current)firstPaint.current = false;
    else refetch();
  }, [number]);

  useEffect(() => {
    const handleWindowResize = () => {
      const { width: width2, height } = getWindowSize();
      dispatch(setWidthHeight(width2, height));
    };
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return (
    <Layout
      style={{ height: '100vh' }}
    >
      <Helmet>
        <title>Taquito Grill - Contacto</title>
        <meta name="description" content="Encuentra todo lo que necesitas para contactarnos: dirección, teléfono, correo electrónico y nuestras redes sociales. ¡Visítanos y descubre una experiencia culinaria inolvidable en nuestro restaurante!" />
      </Helmet>
      <UsersHeader isScrolled />
      <Content
        style={{ overflow: 'auto', position: 'relative', zIndex: 1 }}
      >
        <UsersVisitUs isScrolled />
        <UsersFooter isScrolled />
      </Content>
    </Layout>
  );
}

export default HomeVisitUs;
